import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled FloatingBox
 *
 * @param props - key, show, x, y, width, height, fill, guideBoxProps, children, onMouseDown, onMouseUp, onMouseOver, onMouseLeave, onClick, cursor, opacity, transition, border
 * @example
 * <FloatingBox id="" show={true} x={0} y={0} width={100} height={100} fill='blue' />
 * @returns React.ReactElement
 */
var FloatingBox = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
FloatingBox.defaultProps = {};
var SampleProps = {
    id: '',
    show: false,
    x: 0,
    y: 0,
    width: '100px',
    height: '100px',
};
export default FloatingBox;
export { SampleProps as FloatingBoxSample, };
